import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Divider,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Switch,
    colors,
    TableHead
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';

// import axios from '../../config/axios';
import { useTheme } from '@material-ui/core/styles';
import DetailData from './components/DetailData';
import { classBody } from '@babel/types';
import { get_admin_details, edit_admin_property,get_showroom_operator_details } from '../../api/API';

//const theme = useTheme();
const useStyles = makeStyles(() => ({
    root: {
        padding: '24px',
    },
    leftIcon: {
        //   marginRight: theme.spacing.unit,
    },

}));

export default class DetailShowroomOperator extends React.Component {

    constructor(props) {
        super(props);
        // console.log( this.props.match );

        this.state = {
            admins: null,
            showroom_operator_id: props.showroom_operator_id
        }
    }

    async get_data() {
        const postparam = {
            showroom_operator_id: this.state.showroom_operator_id
        };
       
        var json = await get_showroom_operator_details(this.state.showroom_operator_id);
        if (json) {
            this.setState({
                ...this.state,
                values: {
                    showroom_operator_id: this.state.showroom_operator_id,
                },
                admins: json,
                has_edited: false
            });
        }
    }

    refresh() {
        this.get_data();
    }
    componentDidMount() {
        this.get_data();
    }

    handleChange(e) {
        console.log(e.target.name, e.target.checked);
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.checked,
            },
            has_edited: true
        });
    }

    async submitForm() {
        console.log(this.state.values);
        let data = await edit_admin_property(this.state.values);
        if (data) {
            alert("updated");
            this.setState({
                ...this.state,
                has_edited: false
            });
        }
    }

    render() {
        return (
            <Grid
                {...this.props}
                className={clsx(this.props.classes.root, this.props.className)}
                container
                spacing={1}
                style={{
                    flexDirection: "row"
                }}
            >
                <Grid
                    item
                    lg={8}
                    md={8}
                    xl={8}
                    xs={12}
                >
                    {this.state.admins ?
                        <DetailData
                            {...this.props}
                            refresh={this.refresh.bind(this)}
                            classes={this.props.classes} admins={this.state.admins} /> : ''
                    }
                </Grid>

            </Grid>
        )
    }
}




